var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-padding"},[_vm._m(0),_c('br'),_c('el-row',[_c('div',{attrs:{"id":"containerPie"}})])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-common view-flex view-flex-bottom"},[_c('div',{staticClass:"main"},[_vm._v(" 实时成员收入占比 ")])])
}]

export { render, staticRenderFns }